import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';
import Label from '../Label';

const FilterField = ({
  handleChange,
  labelText,
  placeholderText,
  value,
  name,
  width,
  isTransparent,
  isDisabled,
}) => (
  <>
    <Label text={labelText} htmlFor={name} />
    <S.Filter
      id={name}
      name={name}
      value={value}
      width={width}
      onChange={handleChange}
      placeholder={placeholderText}
      autoCapitalize="off"
      autoComplete="off"
      transparent={isTransparent}
      disabled={isDisabled}
    />
  </>
);

export default FilterField;

FilterField.defaultProps = {
  handleChange: () => {},
  isTransparent: false,
  isDisabled: false,
  width: '',
};

FilterField.propTypes = {
  handleChange: PropTypes.func,
  labelText: PropTypes.string.isRequired,
  placeholderText: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isTransparent: PropTypes.bool,
  isDisabled: PropTypes.bool,
};
